import { createRouteFor } from '@components-common/routes';
const basePath = "/management";
const routeIdBase = "/management";
const routesForManagementArea = createRouteFor<typeof routeIdBase,"management">(routeIdBase,"management");

export const managementAreaRoutes = {
  dashboard: routesForManagementArea("dashboard",{basePath}),
  users: createRouteFor<typeof routeIdBase,"users">(routeIdBase,"users")("index",{basePath}),
  courses: createRouteFor<typeof routeIdBase,"courses">(routeIdBase,"courses")("index",{basePath}),
  analytics: createRouteFor<typeof routeIdBase,"analytics">(routeIdBase,"analytics")("index",{basePath}),
}

// export const managementAreaRoutes = {
//   dashboard: createDashboardRoute<"management">("management",{basePath,roles:['STUDY_DIRECTOR']})
// }

export type ManagementAreaRouteIds = typeof managementAreaRoutes[keyof typeof managementAreaRoutes]["id"];
